exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.answer[data-v-39283e8b]{align-items:center;border:1px solid #ccc;border-radius:5px;color:#767676;display:flex;flex-direction:column;height:48px;justify-content:center;line-height:20px;margin:0 8px 8px 0;width:48px\n}", ""]);

// exports
